var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "17.155 43.155 178.69 125.833",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.835 59.7246H85.8164V49H95.0088V59.7246H117.991V49H127.184V59.7246H150.165V49H159.357V59.7246H174.679C183.14 59.7246 190 66.5843 190 75.0459V147.821C190 155.502 184.349 161.861 176.978 162.97V163.143H38.3213C29.8597 163.143 23.0001 156.283 23 147.821V75.0459C23 66.5843 29.8597 59.7246 38.3213 59.7246H53.6426V49H62.835V59.7246ZM39.8535 145.522H61.3027V124.073H39.8535V145.522ZM77.3896 145.522H98.8398V124.073H77.3896V145.522ZM114.927 145.522H136.376V124.073H114.927V145.522ZM152.463 124.073V145.522H173.913V124.073H152.463ZM39.8535 114.114H61.3027V91.8994H39.8535V114.114ZM77.3896 114.114H98.8398V91.8994H77.3896V114.114ZM114.927 114.114H136.376V91.8994H114.927V114.114ZM152.463 114.114H173.913V91.8994H152.463V114.114ZM38.7109 64.3213C33.4187 64.3214 29.1289 66.8476 29.1289 69.9629C29.1289 70.0325 29.1315 70.1019 29.1357 70.1709H29.1289V78.1104H183.871V70.1709H183.864C183.869 70.1019 183.871 70.0325 183.871 69.9629C183.871 66.8476 179.581 64.3214 174.289 64.3213H159.357V69.6836H150.165V64.3213H127.184V69.6836H117.991V64.3213H95.0088V69.6836H85.8164V64.3213H62.835V69.6836H53.6426V64.3213H38.7109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a260e588e37405645c6826ae19f4e583.svg";
export { ForwardRef as ReactComponent };